import {reactionsData} from '../../helpers/data/reactions-data'

const ReactionItemTemplate = ({type, size, onClick}) => {
  const reaction = reactionsData[type]

  return (
    <div className={`reaction-item ${reaction?.name} ${size}`}>
      {!size && <p className="tooltip">{reaction?.title}</p>}
      <button className="reaction" onClick={onClick}>
        {type === 'PROUD' ? (
          <img className="isotype" src={reaction?.graphic} alt="Organization Isotype" />
        ) : (
          reaction?.graphic
        )}
      </button>
    </div>
  )
}

export default ReactionItemTemplate
